/**
 * Attempts to load a JSON encoded string from the local environment.
 * @param {String} key - name of the env variable.
 */
function get(key) {
  const envVar = key.toUpperCase();
  if (!(envVar in process.env)) {
    throw new Error(`key ${key} as ${envVar} not found in environment`);
  }

  try {
    return JSON.parse(process.env[envVar]);
  } catch (err) {
    return process.env[envVar];
  }
}

module.exports = { get };
